/**
 * 拓扑插件-布局视图名常量定义
 */
export default {
  // 一般视图
  
  // Random Layout：随机布局
  random: 'random',
  
  // 力导向布局：一个布局网络中，粒子与粒子之间具有引力和斥力，从初始的随机无序的布局不断演变，逐渐趋于平衡稳定的布局方式称之为力导向布局。适用于描述事物间关系，比如人物关系、计算机网络关系等
  // Force Layout：经典力导向布局：
  force: 'force',

  // Circular Layout：环形布局
  circular: 'circular',

  // Radial Layout：辐射状布局
  radial: 'radial',

  // MDS Layout：高维数据降维算法布局
  mds: 'mds',

  // Fruchterman Layout：Fruchterman 布局，一种力导布局
  fruChTerMan: 'fruchterman',

  // Dagre Layout：层次布局
  dagre: 'dagre',

  // Concentric Layout：同心圆布局，将重要（默认以度数为度量）的节点放置在布局中心
  concentric: 'concentric',

  // Grid Layout：格子布局，将节点有序（默认是数据顺序）排列在格子上
  grid: 'grid',


  // 树图布局：
  // Dendrogram Layout：树状布局（叶子节点布局对齐到同一层）
  dendrogram: 'dendrogram',

  // CompactBox Layout：紧凑树布局
  compactBox: 'compactbox',

  // Mindmap Layout：脑图布局
  mindMap: 'mindmap',

  // Indented Layout：缩进布局。
  indented: 'indented'
};
